import { Component, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DynamicModule } from '@services/module-loader.config';
import { BaseEntryProductComponent } from './base-entry-product-component';
import {
  PortfolioModule,
  portfolioModuleComponentMapping,
} from './portfolio/portfolio.module';
import {
  OverviewModule,
  overviewModuleComponentMapping,
} from '@products/overview/overview.module';
import { FundSummaryService } from './services/fund-summary.service';
import { FundOverviewService } from './services/fund-overview.service';
import { FundDetailService } from './services/fund-detail.service';
import {
  FundPerformanceModule,
  fundPerformanceModuleComponentMapping,
} from './fund-performance/fund-performance.module';
import {
  OtherFundDetailsModule,
  otherFundDetailsModuleComponentMapping
} from "@products/other-details/other-fund-details.module";
import { PricingHistoryService } from './services/pricing-history.service';
import { FundPerformanceHistoryService } from './services/fund-performance-history.service';
import { RouterModule } from '@angular/router';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    OverviewModule,
    FundPerformanceModule,
    PortfolioModule,
    OtherFundDetailsModule
  ],
  declarations: [BaseEntryProductComponent],
  providers: [
    FundOverviewService,
    FundSummaryService,
    FundDetailService,
    PricingHistoryService,
    FundPerformanceHistoryService,
  ],
})
export class ProductDetailsModule implements DynamicModule {
  getComponentMapping(): {
    [componentName: string]: Component
  } {
    return Object.assign(
      {},
      overviewModuleComponentMapping,
      portfolioModuleComponentMapping,
      fundPerformanceModuleComponentMapping,
      otherFundDetailsModuleComponentMapping
    );
  }
}
